import { createApi } from "@reduxjs/toolkit/query/react";
import endpoints, { baseURL } from "data/api/v1/endpoints.ts";

import {
	APIErrorResponse,
	baseQueryWithRedirect,
	encodePostRequest,
	UntransformedResponse
} from "features/api/utils/apiUtils.ts";
import { models } from "types/api/viewModels.ts";
import { AddressValidateResponse } from "pages/Replacements/components/AddNewAddressModal/components/ConfirmAddress.tsx";

export const addressApiSlice = createApi({
	reducerPath: "addressApi",
	baseQuery: baseQueryWithRedirect(baseURL),
	endpoints: (builder) => ({
		getAddressSuggestions: builder.query<models["AddressViewModel"][], string>({
			query: (address: string) => endpoints.addresses.getSuggestions(address),
			transformResponse: (response: { data: models["AddressViewModel"][] }) => response?.data,
			transformErrorResponse: (error: { status: string | number }) => ({
				status: error?.status
			})
		}),
		validateAddress: builder.mutation<AddressValidateResponse, models["AddressViewModel"]>({
			query: (address: models["AddressViewModel"]) => ({
				url: endpoints.addresses.validateAddress(),
				method: "POST",
				dataType: "json",
				headers: {
					"Content-type": "application/json; charset=UTF-8"
				},
				body: encodePostRequest(address)
			}),
			transformResponse: (response: UntransformedResponse<AddressValidateResponse>) => response?.data,
			transformErrorResponse: (error: UntransformedResponse<APIErrorResponse>) => ({
				status: error?.status
			})
		})
	})
});

export const { useLazyGetAddressSuggestionsQuery, useValidateAddressMutation } = addressApiSlice;
